import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AuthLayout from "../components/AuthLayout";
import FormField from "../components/FormField";
import Button from "../components/Button";
import Alert from "../components/Alert";
import { cerberus } from "../api/cerberus";
import { useSubmit } from "../lib/useSubmit";

export default function PasswordResetConfirm(): JSX.Element {
  const [search] = useSearchParams();
  const token = search.get("token") ?? "";
  const userId = search.get("user_id") ?? "";

  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);

  const { busy, error, onSubmit } = useSubmit(async () => {
    await cerberus.passwordResetConfirm({
      token,
      user_id: userId,
      new_password: password,
    });
    setDone(true);
  }, "reset failed");

  if (!token || !userId) {
    return (
      <AuthLayout title="Link invalido">
        <Alert variant="error">Token ou user_id ausente na URL.</Alert>
        <Link to="/forgot">Solicitar novo link</Link>
      </AuthLayout>
    );
  }

  if (done) {
    return (
      <AuthLayout title="Senha redefinida">
        <Alert variant="success">Pronto. Voce ja pode entrar com a nova senha.</Alert>
        <Link to="/login">Ir para login</Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Nova senha"
      footer={<Link to="/login">Voltar ao login</Link>}
    >
      {error ? <Alert variant="error">{error}</Alert> : null}
      <form onSubmit={onSubmit} noValidate>
        <FormField
          label="Nova senha"
          name="new_password"
          type="password"
          autoComplete="new-password"
          minLength={8}
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button type="submit" disabled={busy}>
          {busy ? "Salvando..." : "Salvar senha"}
        </Button>
      </form>
    </AuthLayout>
  );
}
